import React, {FC} from 'react'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import {IconButton, Tooltip, Typography} from '@mui/material'
import {format} from 'date-fns'
import {TitleLink} from '@components/UI/styled'
import PencilIcon from '@components/UI/Icons/Pencil'
import ArchiveIcon from '@components/UI/Icons/ArchiveIcon'
import UnzipIcon from '@components/UI/Icons/UnzipIcon'
import {VisibleIcon} from '@components/UI/Icons/VisibleIcon'
import {StoryStatus} from '@graphql/types'
import {StoryAction} from '../../../../types/story/StoryAction'
import {STORIES_ITEM_CONSTS} from './StoriesItem.consts'
import {
  ButtonsWrapper,
  DesktopDateWrapper,
  ImageWrapper,
  ItemContentWrapper,
  ItemInfo,
  ItemWrapper,
  MobileDateWrapper,
  PublicationsCountWrapper,
  Title
} from './StoriesItem.styles'
import {StoryItemProps} from './StoriesItemProps'

const StoriesItem: FC<StoryItemProps> = ({story, storyAction}) => {
  const handleOpenStoryOnSite = (url: string) => {
    console.log('STORIES ITEM')
    if (url) {
      window.open(`${process.env.REACT_APP_URA_NEWS_URL}story/${url}`, '_blank')
    }
  }  
    return (
    <ItemWrapper>
      <ItemInfo>
        <DesktopDateWrapper>
          <Typography variant='text14R'>
            {format(new Date(story.updatedAt || story.createdAt), 'dd.MM.yyyy')}
          </Typography>
        </DesktopDateWrapper>
        <ImageWrapper
          style={{
            background: story.figureVersion?.primaryProcessedImage?.url
              ? `url(${story.figureVersion?.primaryProcessedImage?.url})`
              : 'black',
            backgroundSize: 'cover'
          }}
        />
        <ItemContentWrapper>
          <MobileDateWrapper>
            <Typography variant='text14R'>
              {format(new Date(story.updatedAt || story.createdAt), 'dd.MM.yyyy')}
            </Typography>
          </MobileDateWrapper>
          <Title>
            <TitleLink to={`story/editor/${story.uid}`} title={STORIES_ITEM_CONSTS.goToEditing}>
              <Typography variant='text16M'>{story.title || STORIES_ITEM_CONSTS.withoutName}</Typography>
            </TitleLink>
          </Title>
          <PublicationsCountWrapper>
            <Typography color='secondary' component='span' variant='text12R' marginTop={'6px'}>
              {STORIES_ITEM_CONSTS.publicationsCount}: {story.publicationsCount}
            </Typography>
          </PublicationsCountWrapper>
        </ItemContentWrapper>
      </ItemInfo>
      <ButtonsWrapper>
        {story.status === StoryStatus.Active && (
          <Tooltip title={STORIES_ITEM_CONSTS.viewOnSite}>
            <IconButton
              aria-label={STORIES_ITEM_CONSTS.viewOnSite}
              onClick={() => handleOpenStoryOnSite(story.canonicalUrl || '')}
            >
              <VisibleIcon color='secondary' width={34} height={34} />
            </IconButton>
          </Tooltip>
        )}
        {[StoryStatus.Active, StoryStatus.Archive].includes(story.status) && (
          <Tooltip title={STORIES_ITEM_CONSTS.goToEditing}>
            <IconButton
              aria-label={STORIES_ITEM_CONSTS.goToEditing}
              onClick={() => storyAction(story.uid, StoryAction.EDIT)}
            >
              <PencilIcon width={18} height={18} className='icon' color='disabled' />
            </IconButton>
          </Tooltip>
        )}
        {story.status === StoryStatus.Active && (
          <Tooltip title={STORIES_ITEM_CONSTS.archivateStory}>
            <IconButton
              aria-label={STORIES_ITEM_CONSTS.archivateStory}
              onClick={() => storyAction(story.uid, StoryAction.ARCHIVE)}
            >
              <ArchiveIcon className='icon' color='disabled' />
            </IconButton>
          </Tooltip>
        )}
        {story.status === StoryStatus.Archive && (
          <Tooltip title={STORIES_ITEM_CONSTS.unzipStory}>
            <IconButton
              aria-label={STORIES_ITEM_CONSTS.unzipStory}
              onClick={() => storyAction(story.uid, StoryAction.UNZIP)}
            >
              <UnzipIcon className='icon' color='disabled' />
            </IconButton>
          </Tooltip>
        )}
        {[StoryStatus.Active, StoryStatus.Archive].includes(story.status) && (
          <Tooltip title={STORIES_ITEM_CONSTS.deleteStory}>
            <IconButton
              aria-label={STORIES_ITEM_CONSTS.deleteItem}
              onClick={() => storyAction(story.uid, StoryAction.DELETE)}
            >
              <DeleteForeverIcon className='icon' color='disabled' />
            </IconButton>
          </Tooltip>
        )}
      </ButtonsWrapper>
    </ItemWrapper>
  )
}

export default StoriesItem
